import { NavLink } from 'react-router-dom';

import { Add16 } from '@ingrid/iconography/react';
import { Button, InteractiveTable, PageTitle, PageWrapper } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { Breadcrumb } from '../breadcrumb';
import { useFilteredCarrierContractsListQuery } from '../queries';
import { Filters } from './filters/filters';
import { Tags } from './filters/tags';
import { ListTable } from './list-table';

export function Page() {
  const { data: filteredContracts, isFetched, isFetching } = useFilteredCarrierContractsListQuery();
  const { t } = useTranslation();

  return (
    <InteractiveTable.Provider allowHighlight keepInactive>
      <PageWrapper>
        <PageTitle.Wrapper>
          <PageTitle.Stack>
            <Breadcrumb />
          </PageTitle.Stack>

          <RoleGuard roles={['transport:edit']} withTooltip>
            <Button as={NavLink} to={`${AppRoute.CREATE}`}>
              <Add16 />
              {t('carrierContracts.list.addContract')}
            </Button>
          </RoleGuard>
        </PageTitle.Wrapper>

        <Filters />
        <Tags />

        <section style={{ backgroundColor: 'inherit' }}>
          <ListTable
            loadRowCount={isFetched ? filteredContracts.length : 10}
            isEmpty={isFetched && !filteredContracts.length}
            carrierContracts={filteredContracts}
            loading={isFetching}
          />
        </section>
      </PageWrapper>
    </InteractiveTable.Provider>
  );
}
